import { Spinner } from "@jobber/components/Spinner";
import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { instagramAuthorize } from "services";

const InstagramCallback = () => {
    const [searchParams] = useSearchParams();
    const code = searchParams.get("code");
    const state = searchParams.get("state");
    const navigate = useNavigate();

    useEffect(() => {
        // Declining the Instagram consent screen sends us back with an error instead of a
        // code. Send the user to step 1 so the banner there offers them another attempt.
        const error = searchParams.get("error");
        if (error) {
            const description = searchParams.get("error_description");
            navigate("/jobber-instagram-step1", {
                replace: true,
                state: { error: description ?? "Instagram authorization was cancelled." },
            });
            return;
        }

        if (!code || !state) {
            navigate("/error", { replace: true });
            return;
        }

        (async () => {
            try {
                const res = await instagramAuthorize(code, state);
                sessionStorage.setItem("state", res.state);
                if (res.username) {
                    sessionStorage.setItem("instagram_username", res.username);
                }
                navigate("/jobber-instagram-step2", { replace: true });
            } catch (e: any) {
                navigate("/jobber-instagram-step1", { replace: true, state: { error: e.message } });
            }
        })();
    }, []);

    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                height: "100%",
            }}
        >
            <Spinner />
            <h1>Instagram authentication in progress</h1>
        </div>
    );
};

export default InstagramCallback;
